__webpack_require__.p = "https://inventory-solution-app.boolanga.com/";